import React, { useRef, useState } from 'react';
import JoditEditor from 'jodit-react';
import { Utility } from 'helpers/CalendarImports';

interface HtmlEditorProps {
  title?: string;
  content: string | undefined;
  setContent: (value: string) => void;
  size?: [number, number, number, string?] | null | undefined;
  height?: number;
  className?: string;
  placeholder?: string;
}

const HtmlEditor: React.FC<HtmlEditorProps> = ({ 
  title, 
  content, 
  setContent, 
  size,  
  height = 450, 
  className = '',
  placeholder='',
}) => {
  const editor = useRef(null);
 
  const config = {
    readonly: false,
    height: height,
    toolbarAdaptive: false,
    toolbarSticky: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    toolbar: true,
    placeholder: placeholder,
    askBeforePasteHTML: false,
    pasteHTML: true,
    buttons: [
      'undo', 'redo', '|', 
      'bold', 'italic', 'underline', '|', 
      'ul', 'ol', '|',  
      'fontsize', 'align','|', 
      'brush', 'link', 'table','source'
    ]
  };

  return (
    <div className={`html-editor ${size ? Utility.Convert.formColumnStyle(size) : 'form-col100'} ${className}`}>
      <div>
        {title && (
          <label>{title}</label>
        )} 
        <JoditEditor
          ref={editor}
          value={content}
          config={config}
          onBlur={(newContent) => setContent(newContent)}
        />
      </div>
    </div>
  );
};

export default HtmlEditor;